export default __webpack_public_path__ + "static/media/warning.69c90934.svg";